import { IconButton, Popover } from "@commonlibs";
import { useState } from "react";
import useTranslate from "ui/locale/hooks/useTranslate";
import { ActionMenuItem, ActionsMenuPopoverPaper } from "./ActionsMenu.styles";
import { MenuAction, ActionsMenuProps } from "./ActionsMenu.types";
import OptionsIcon from "ui/common/icons/OptionsIcon";

const ActionsMenu = ({ actions, customButton }: ActionsMenuProps) => {
    const translate = useTranslate();
    const [visible, setVisible] = useState<boolean>(false);

    const handleActionClick = (action: MenuAction) => {
        setVisible(false);
        action.onClick();
    };

    return (
        <Popover showOn="click" visible={visible} onShow={() => setVisible(true)} onHide={() => setVisible(false)} position="bottom-start">
            <Popover.Popper>
                <ActionsMenuPopoverPaper>
                    {actions.map((action, index) => (
                        <ActionMenuItem onClick={() => handleActionClick(action)} variant="body2Light" key={index}> {/** // skipcq: JS-0437 */}
                            {translate(action.label)}
                        </ActionMenuItem>
                    ))}
                </ActionsMenuPopoverPaper>
            </Popover.Popper>
            <Popover.Content>
                <IconButton onClick={() => setVisible(!visible)} css={{ fontSize: "1.25rem" }}>
                    {customButton ?? <OptionsIcon />}
                </IconButton>
            </Popover.Content>
        </Popover>
    );
};

export default ActionsMenu;
